import gql from 'graphql-tag'

export const AuthenticationUserFragment = gql`
	fragment AuthenticationUser on User {
		id
		firstName
		profile {
			hasAvatar
			avatarContentType
			avatarPath
		}
	}
`